import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createSlots as _createSlots } from "vue";
import { onMounted, reactive, ref } from "vue";
import apis from "@/api";
import { ElMessage, ElMessageBox } from "element-plus";
import _ from 'lodash';
import { addChannel } from "@/api/modules/extChannel";
export default {
  __name: 'Info',
  props: {
    title: {
      type: String,
      default: '添加渠道信息',
      required: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  emits: ['success', 'update:visible'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emits = __emit;
    const props = __props;
    const formRef = ref(null);
    const data = reactive({
      form: {},
      rules: {
        channelCode: [{
          required: true,
          message: "请输入渠道编码",
          trigger: "blur"
        }],
        channelName: [{
          required: true,
          message: "请输入渠道名称",
          trigger: "blur"
        }],
        businessLicense: [{
          required: true,
          message: "请输入营业执照",
          trigger: "blur"
        }],
        contactName: [{
          required: true,
          message: "请输入联系人姓名",
          trigger: "blur"
        }],
        contactPhone: [{
          required: true,
          message: "请输入联系人电话",
          trigger: "blur"
        }]
      }
    });
    const elLoading = ref(false);
    const initEdit = row => {
      data.form = row;
    };
    const close = () => {
      data.form = {};
      emits('update:visible', false);
    };
    const editFun = () => {
      apis.editChannel(data.form).then(res => {
        if (res.success) {
          ElMessage.success("修改成功!");
          emits("success");
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        elLoading.value = false;
        close();
      });
    };
    const addFun = () => {
      apis.addChannel(data.form).then(res => {
        if (res.success) {
          ElMessage.success("添加成功!");
          emits("success");
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        elLoading.value = false;
        close();
      });
    };
    const handleSave = () => {
      formRef.value.validate(valid => {
        if (valid) {
          elLoading.value = true;
          console.log(data.form);
          if (data.form.id) {
            editFun();
          } else {
            addFun();
          }
        }
      });
    };
    __expose({
      initEdit
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: __props.title,
        "model-value": __props.visible,
        onClose: close,
        "close-on-press-escape": false,
        "destroy-on-close": true,
        width: "40%"
      }, _createSlots({
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: data.form,
          rules: data.rules,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "渠道编码",
            prop: "channelCode"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.form.channelCode,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.form.channelCode = $event),
              disabled: !__props.edit
            }, null, 8, ["modelValue", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "渠道名称",
            prop: "channelName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.form.channelName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.form.channelName = $event),
              disabled: !__props.edit
            }, null, 8, ["modelValue", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "营业执照",
            prop: "businessLicense"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.form.businessLicense,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.form.businessLicense = $event),
              disabled: !__props.edit
            }, null, 8, ["modelValue", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "联系人姓名",
            prop: "contactName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.form.contactName,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => data.form.contactName = $event),
              disabled: !__props.edit
            }, null, 8, ["modelValue", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "联系人电话",
            prop: "contactPhone"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.form.contactPhone,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => data.form.contactPhone = $event),
              disabled: !__props.edit
            }, null, 8, ["modelValue", "disabled"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])), [[_directive_loading, elLoading.value]])]),
        _: 2
      }, [__props.edit ? {
        name: "footer",
        fn: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: close
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("取消", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSave
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("保存", -1)]))]),
          _: 1
        })]),
        key: "0"
      } : undefined]), 1032, ["title", "model-value"]);
    };
  }
};